import { useQuery } from 'react-query';
import { model, Language } from './language';

export const languagesQueryKey = 'languages';

export const useLanguages = () => useQuery<Language[]>(languagesQueryKey, () => model.getList());
